export const filingStatesSelector = ({ filingStates }) => filingStates.filingStates;

export const isFetchingFilingStatesSelector = ({ filingStates }) =>
  filingStates.isFetchingFilingStates;
